import React, {Component} from "react";
import {BannerHeader} from "../structure";
import {Footer} from './../common/common';

import bgImg from "../../resources/images/bg-register.jpg"

class TermsOfTrade extends Component {
	componentDidMount() {
		document.getElementById("content").scrollTo(0, 0);
	}
	render(){
		return(
			<article className="festenInfoPage">
				<BannerHeader bgImage={bgImg}>
					<h1>Handelsbetingelser</h1>
				</BannerHeader>
				<div className="maxWidth">
					<section className="infoSection">
						<h1>Festen.dk</h1>
						<p>Festen.dk optr&aelig;der alene som mellemmand og ikke s&aelig;lger. Det er samarbejdspartnere, og ikke
							Festen.dk, som leverer varerne. Samarbejdspartneren er ansvarlig for at aftalen opfyldes og er forbrugerens
							egentlige aftalepart. Se varekortet og ordrebekr&aelig;ftelsen for information on aftalepart.</p>
						<p>Disse salgs- og leveringsbetingelser finder anvendelse p&aring; k&oslash;b af vare p&aring; Festen.dk til
							levering i Danmark, dog ikke Gr&oslash;nland og F&aelig;r&oslash;erne, medmindre andet er udtrykkeligt
							aftalt.</p>
						<p>
							Festen<br />
							CVR-nr 34725195<br />
							Sdr. Boulevard 42, kld. tv.,<br />
							5000 Odense C<br />
						</p>
					</section>

					<section className="infoSection">
						<h1>Links</h1>
						<a href="http://www.betaling.dk/">PBS - Pengeinstitutternes Betalings Service</a><br />
						<a href="http://www.forbrugersikkerhed.dk/">FDIH / Forbrugerr&aring;det</a><br />
						<a href="http://www.forbrug.dk/">Forbrugerstyrelsen</a><br />
						<a href="http://www.fbr.dk/">Forbrugerr&aring;det</a><br />
						<a href="http://www.fi.dk/">Forbrugerinformation</a>
					</section>

					<section className="infoSection">
						<h1>Misbrug</h1>
						<p>Misbrug af Festen.dk ApS medf&oslash;rer til politianmeldelse.</p>
					</section>
					
					<section className="infoSection">
						<h1>Bestilling og Betaling</h1>
						<p>
							Festen.dk er &aring;ben 24 timer i d&oslash;gnet, og du kan derfor n&aelig;sten altid handle. Det kan dog
							ske, at vi lukker butikken grundet vedligeholdelse. Du kan foretage k&oslash;b n&aring;r butikken
							er &aring;ben og tilg&aelig;ngelig.
						</p>
						<p>
							For at handle p&aring; Festen.dk skal du v&aelig;re fyldt 18 &aring;r og i besiddelse af gyldigt
							betalingskort, som vi acceptere. Hvis du endnu ikke er fyldt 18 &aring;r kan du dog alligevel k&oslash;be
							varer, hvis du har indhentet din v&aelig;rges accept eller i &oslash;vrigt at juridisk ret til at
							indg&aring; k&oslash;bet. Festen modtager betaling med Dankort/VISA-Dankort, VISA, VISA Electron og
							Mastercard. Alle bel&oslash;b er i DKK. Danske kroner og er inkl. Moms.
						</p>
						<p>
							Festen bruger en godkendt betalingsserver, der krypterer alle dine kortoplysninger med SSL (Secure Socket
							Layer) protokol. Det betyder, at man ikke kan afl&aelig;se dine informationer.
						</p>
						<p>
							Du v&aelig;lger de varer, du vil k&oslash;be, og l&aelig;gger dem i &rdquo;indk&oslash;bskurven&rdquo;. Du
							kan helt frem til selve bestillingstidspunktet rette i indholdet af indk&oslash;bskurven, og du kan
							l&oslash;bende tjekke indholdet samt prisen for varerne.
						</p>
						<p>
							Eventuelle ekstra betalinger for f.eks. fragt og betalingskortgebyrer vil f&oslash;rst blive udregnet,
							umiddelbart inden du er klar til betale.
						</p>
						<p>
							N&aring;r du er klar til at bestille, klikker du p&aring; "g&aring; til kassen", hvor du indtaster dit navn,
							adresse, e-mail, tlf.nr., betalingsform og v&aelig;lger leveringsform.
						</p>
						<p>
							Du kan &aelig;ndre dit indhold i indk&oslash;bskurven helt frem til, du bekr&aelig;fter dit k&oslash;b ved
							acceptere og gennemf&oslash;re betalingen. Her efter g&aring;r din ordre videre til butikken via
							Festen.dk
						</p>
						<p>
							Pengene bliver f&oslash;rst trukket fra dit betalingskort, n&aring;r varen er afsendt fra butikken.
						</p>
						
						<h2>Kvittering for modtagelse af bestilling og ordrebekr&aelig;ftelse</h2>
						<p>
							Hver gang du bestiller en vare igennem Festen.dk, sender vi en ordrebekr&aelig;ftelse til dig som kunde og en
							ordre ned til den butik, du k&oslash;ber varen fra, som efterf&oslash;lgende pakker din vare og sender den
							afsted til dig.
						</p>
					
						<h2>Leveringstidspunkt og transport</h2>
						<p>
							Levering af varer fra Festen.dk anses for sket, n&aring;r kunden har f&aring;et varen udleveret. Alle
							bestillinger sendes med Post Danmark/GLS, hvis ikke andet er aftalt s&aelig;rskilt mellem k&oslash;ber og
							Festen.dk. Ved enkelte samarbejdspartnere er der mulighed for enten at hente varen selv, eller at
							samarbejdspartnere levere varen, dette v&aelig;lges under levering. Dette betyder, at varene sendes indenfor
							maksimalt 5 dage efter modtaget ordre. Levering p&aring; k&oslash;bers adresse i Danmark vil derfor normalt
							ske indenfor 3 dage. Oplyste leveringstidspunkt er vejledende og kan s&aring;ledes fravige.
						</p>

						<h2 id="Prismatch">Prismatch</h2>
						<p>
							Hos Festen vil vi gerne sikre at vores kunder gør en god handel. 
							Derfor matcher vi prisen, hvis du finder en identisk vare billigere hos andre danske webshops. 
						</p>
						<h3>Sådan virker det:</h3>
						<p>
							Send os en mail med oplysninger om hvor du har set varen billigere, 
							vedhæft et billede/screenshot eller lignende, som dokumentation. Så vil vi refundere forskellen til det anvendte betallingskort. 
							Prismatchen gælder op til 14 dage efter en gennemført handel. 
						</p>
						<p><i>Send mail til kontakt@festen.dk</i></p>
						<h3>Betingelser:</h3>
						<ul>
							<li>Varen skal være på lager hos den anden forhandler før prismatchen kan være gyldig</li>
							<li>Den anden forhandlers pris skal være gyldig </li>
							<li>Leveringspriser/fragt/pant mm. Medregnes ikke ifht. Prismatch</li>
							<li>Gælder ikke ophørsudsalg, køtilbud, begrænsede tilbud eller anden sorterings varer. </li>
							<li>Prismatch gælder kun for private forbrugere</li>
							<li>Rabatter, kupponer eller andre medlemsfordele medregnes ikke ifht. Prismatch. </li>
							<li>Festen forbeholder sig ret til at ændre i prismatch konceptet uden varsel. </li>
						</ul>

						<h2>Reklamation</h2>
						<p>
							OBS: Eftersom Festen.dk ikke er aftalepart, s&aring; skal alle reklamationer g&aring; igennem forhandleren af
							varen. Du kan se p&aring; din ordrebekr&aelig;ftelse, hvem der er aftalepart. Alternativt kan du henvende
							dig til Festen.dk, s&aring; du kan s&aelig;ttes i forbindelse med din aftalepart.
						</p>
						<p>
							Dit k&oslash;b er omfattet k&oslash;beloven, herunder mangel reglerne. Det betyder, at du enten kan
							f&aring; en mangelfuld vare repareret, ombyttet, pengene tilbage eller afslag i prisen, afh&aelig;ngig af
							den konkrete situation. Det er selvf&oslash;lgelig et krav, at reklamationen er berettiget, og at manglen
							ikke er opst&aring;et som f&oslash;lge af fejlagtig brug af produktet eller anden skadeforvoldende
							adf&aelig;rd.
						</p>
						<p>
							En reklamationssag er en sag mellem dig og forhandleren. Vi vil formidle kontakten men er uden ansvar for
							varens mangel.
						</p>
					
						<h2>Kontakt os indenfor &ldquo;rimelig tid&rdquo;</h2>
						<p>
							Du skal reklamere indenfor &ldquo;rimelig tid&rdquo; efter, du har opdaget manglen ved varen. Vi anbefaler,
							at du reklamere s&aring; hurtigt som muligt, og inden for 2 m&aring;neder efter fejlen blev opdaget.
						</p>
						<p>
							Du kan reklamere ved at kontakte os via mail til <a href="mailto:kontakt@festen.dk">kontakt@festen.dk</a> eller p&aring; telefon p&aring; (+45) 78
							70 78 88. Afh&aelig;ngig af den konkrete situation vil du modtage de videre instrukser. N&aring;r du
							returnere varen, bedes du, s&aring; detaljeret som muligt, beskrive hvad problemet er.
						</p>
					
						<h2>14 dages fortrydelsesret</h2>
						<p>
							N&aring;r du handler p&aring; nettet og hos<a href="http://www.festen.dk"> www.festen.dk</a> har du normalt
							14 dages fortrydelsesret, hvor du kan meddele os, at du fortryder k&oslash;bet og derp&aring; returnere
							varen til os. Det er din aftalepart, som varetager fortrydelses sager.
						</p>
						<p>
							Fortrydelsesretten l&oslash;ber fra den dag, du har modtaget varen. Hvis fristen udl&oslash;ber p&aring; en
							helligdag, l&oslash;rdag, grundlovsdag, juleaften eller nyt&aring;rsaftensdag, forl&aelig;nges fristen til
							den f&oslash;lgende hverdag.
						</p>
						<p>
							Du m&aring; efter modtagelsen alene h&aring;ndtere varerne p&aring; en m&aring;de, s&aring; du kan
							fastsl&aring; varernes art, egenskaber og den m&aring;de, som de fungere p&aring;.
						</p>
						<p>
							For at g&oslash;re fortrydelsesretten g&aelig;ldende, skal du ved en utvetydig erkl&aelig;ring give os besked
							herom senest 14 dage efter modtagelsen af varen.
						</p>
						<p>
							Man fraskriver sig fortrydelsesretten ved k&oslash;b af vare der er specificeret til kundens behov.
						</p>
					
						<h2>Returnering</h2>
						<p>
							Hvis du fortryder k&oslash;bet, skal varerne tilbageleveres til den butik, som har sendt vare i f&oslash;rste
							omgang. Ved tilbageleveringen b&oslash;r du s&oslash;rge for, at varene er forsvarligt indpakket. Du har
							nemlig selv ansvaret for at pakken/varerne, indtil butikken modtager den. Gem derfor kvitteringen for
							afsendelse samt track and trace nummeret.
						</p>
						<p>
							Vi forventer, at du afsender varerne hurtigst muligt efter du har besked om fortrydelse, og du skal sende dem
							retur senest 14 dage efter, du har fortrudt.
						</p>
						
					</section>
					
					<section className="infoSection">
						<h1>Persondata loven</h1>
						<p>
							Festen.dk indsamler dine personoplysninger, for at du kan indg&aring; en handel med os p&aring;<a
							href="http://www.festen.dk"> www.festen.dk</a>. Indsamlingen af din personoplysninger sker n&aring;r du
							godkender vores handelsbetingelser.
						</p>
						<p>
							Vi indsamler nedenst&aring;ende oplysninger:
						</p>
						<p>
							-Navn<br />
							-Adresse<br />
							-E-mail adresse<br />
							-Telefonnummer/mobilnummer
						</p>
						<p>
							Overst&aring;ende data bliver gemt med oplysninger om, hvilke vare du har k&oslash;bt, i 5 &aring;r fra
							udgangen af det regnskabs&aring;r, oplysningerne vedr&oslash;rer, jf. Bogf&oslash;ringsloven &sect;10,
							hvorefter oplysningerne slettes.
						</p>
						<p>
							Vi opbevarer ikke kundeoplysninger krypteret.
						</p>
						<p>
							Vi transmitterer ikke kundeoplysninger krypteret.
						</p>
						<p>
							Oplysninger afgivet til Festen.dk ApS videregives til vores leverand&oslash;r for at kunde sende varen til
							Kunden, dog registrerer vi ingen personf&oslash;lsomme oplysninger.
						</p>

						<h2>Hvad bruges mine oplysninger til?</h2>
						<p>
							Vi benytter f&oslash;rst og fremmest dine oplysninger til at behandle og fremsende din ordre foretaget
							p&aring;<a href="http://www.festen.dk"> www.festen.dk</a>. Vi bruger ogs&aring; dine oplysninger i
							forbindelse med markedsf&oslash;ring og konkurrencer s&aring;fremt du er tilmeldt vores nyhedsbrev og har
							givet samtykke hertil.
						</p>
						<p>
							Vi vil i nogle tilf&aelig;lde ogs&aring; benytte dine oplysninger til efterforskning ved mistanke om
							svindel.
						</p>

						<h2>Hvem deles min oplysninger med?</h2>
						<p>
							Hos Festen handels der direkte med fysiske butikker p&aring; vores platform www.festen.dk . For at butikkerne
							kan behandle og fremsende din ordre, deles dine oplysninger med de butikker som skal levere din ordre.</p>
						<p>
							Ligeledes deles dine oplysninger med eksterne distribut&oslash;rer, GLS og Postnord.
						</p>
						<p>
							Vi registrerer ingen personf&oslash;lsomme oplysninger.
						</p>
						<p>
							Som registreret hos Festen har du altid ret til at g&oslash;re indsigelse mod registreringen. Du har
							ogs&aring; ret til indsigt i, hvilke oplysninger der er registreret om dig. Disse rettigheder har du efter
							persondataloven. Henvendelse i forbindelse hermed rettes til Festen via e-mail: <a href="mailto:kontakt@festen.dk">kontakt@festen.dk</a>
						</p>
					</section>
				</div>
				<Footer/>
			</article>
		)
	}
};

export default TermsOfTrade;



// WEBPACK FOOTER //
// ./src/components/infoPages/termsoftrade.js